import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Leaf } from 'lucide-react';
export function Hero() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  useEffect(() => {
    // Load Wistia player script
    const script1 = document.createElement('script');
    script1.src = 'https://fast.wistia.com/player.js';
    script1.async = true;
    document.body.appendChild(script1);
    const script2 = document.createElement('script');
    script2.src = 'https://fast.wistia.com/embed/hwca5ao9gj.js';
    script2.async = true;
    script2.type = 'module';
    document.body.appendChild(script2);
    return () => {
      document.body.removeChild(script1);
      document.body.removeChild(script2);
    };
  }, []);
  return <section className="relative w-full overflow-hidden bg-brand-cream pt-6 pb-12 lg:pt-12 lg:pb-20" data-id="element-64">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-65">
        {/* Logo / Header area */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="flex items-center justify-center lg:justify-start mb-8 lg:mb-12" data-id="element-66">
          <div className="flex items-center gap-2 text-brand-green" data-id="element-67">
            <Leaf className="h-6 w-6 fill-current" data-id="element-68" />
            <span className="font-heading font-bold text-xl tracking-tight" data-id="element-69">
              Quincena en Verde™
            </span>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-70">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-center lg:text-left" data-id="element-71">
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-brand-dark leading-tight mb-6" data-id="element-72">
              Tu quincena deja de desaparecer en{' '}
              <span className="text-brand-green" data-id="element-73">7 días</span>
            </h1>

            <p className="font-sans text-lg sm:text-xl text-brand-text/80 mb-6 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-74">
              El sistema de 3 sobres (sin Excel) que te da claridad en 10
              minutos y te ayuda a cortar gastos invisibles desde el día 1.
            </p>

            {/* Wistia Video */}
            <div className="mb-8 rounded-xl overflow-hidden shadow-lg max-w-2xl mx-auto lg:mx-0" data-id="element-75">
              <style dangerouslySetInnerHTML={{
              __html: `
                  wistia-player[media-id='hwca5ao9gj']:not(:defined) { 
                    background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/hwca5ao9gj/swatch'); 
                    display: block; 
                    filter: blur(5px); 
                    padding-top: 56.25%; 
                  }
                `
            }} data-id="element-76" />
              <wistia-player media-id="hwca5ao9gj" aspect="1.7777777777777777" data-id="element-77"></wistia-player>
            </div>

            <div className="flex flex-wrap justify-center lg:justify-start gap-3 mb-8 text-sm font-medium text-brand-green bg-brand-green/5 py-2 px-4 rounded-full w-fit mx-auto lg:mx-0" data-id="element-78">
              <span data-id="element-79">Sin Excel</span>
              <span className="w-1 h-1 rounded-full bg-brand-green/40 self-center" data-id="element-80"></span>
              <span data-id="element-81">10 min al día</span>
              <span className="w-1 h-1 rounded-full bg-brand-green/40 self-center" data-id="element-82"></span>
              <span data-id="element-83">Hecho para quincena/biweekly</span>
            </div>

            <div className="flex flex-wrap justify-center lg:justify-start gap-3 mb-8 text-sm font-medium text-brand-dark bg-brand-gold/10 py-2 px-4 rounded-full w-fit mx-auto lg:mx-0" data-id="element-84">
              <span data-id="element-85">Pagas 1 y recibes 6 ebooks 🎁</span>
              <span className="w-1 h-1 rounded-full bg-brand-gold/40 self-center" data-id="element-86"></span>
              <span data-id="element-87">Acceso inmediato⚡</span>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-88">
              <button onClick={scrollToOffer} className="bg-brand-green hover:bg-brand-dark text-white font-heading font-bold py-4 px-8 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:scale-[1.02] flex items-center justify-center gap-2 text-lg" data-id="element-89">
                Empezar mi plan de 7 días
                <ArrowRight className="h-5 w-5" data-id="element-90" />
              </button>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative mx-auto lg:mx-0 w-full max-w-md lg:max-w-full" data-id="element-91">
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-92">
              <img src="https://cdn.magicpatterns.com/uploads/ktuDCM4PB5ddUfAehAf3Q2/Producto_Principal.png" alt="Quincena en Verde Ebook y Sistema" className="w-full h-auto object-cover" data-id="element-93" />
            </div>
            {/* Decorative elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-brand-gold/20 rounded-full blur-xl z-0" data-id="element-94"></div>
            <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-brand-green/10 rounded-full blur-xl z-0" data-id="element-95"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}